// extracted by mini-css-extract-plugin
export default {"menuItems":"Menu_menuItems__alj7S","menuItem":"Menu_menuItem__f+n-f"};